import type { JSX } from "react";

import ArrowRight from "@repo/icons/default/ArrowRight";

import type { Profession } from "@/components/flows/steps/council/utils/professions";
import { Button } from "@/components/ui/button/button";
import { SearchInput } from "@/components/ui/input/search-input";
import {
  CardSelectDescription,
  CardSelectItem,
  CardSelectItemContainer,
  CardSelectRoot,
  CardSelectTitle,
} from "@/components/ui/select-input/card-select.tsx";

interface CouncilProfessionSubStepProps {
  professions: Profession[];
  filteredProfessions: Profession[];
  onSearch: (results: Profession[]) => void;
  defaultValue?: string | null;
  onChange: (value: string) => void;
  title: string;
  description?: string;
  buttonText: string;
  isLoading?: boolean;
  isValid: boolean;
  onContinue: () => void;
}

export const CouncilProfessionSubStep = ({
  professions,
  filteredProfessions,
  onSearch,
  defaultValue,
  onChange,
  title,
  description,
  buttonText,
  isLoading,
  isValid,
  onContinue,
}: CouncilProfessionSubStepProps): JSX.Element => {
  return (
    <div className="flex flex-col gap-4 h-full justify-between">
      <CardSelectRoot
        onChange={onChange}
        name="profession"
        className="gap-4 pb-6"
        defaultValue={defaultValue ?? undefined}
      >
        <div>
          <CardSelectTitle>{title}</CardSelectTitle>
          {description ? (
            <CardSelectDescription>{description}</CardSelectDescription>
          ) : null}
        </div>

        <SearchInput
          items={professions}
          onSearch={onSearch}
          searchKeys={["label"]}
          placeholder="Buscar"
        />

        <CardSelectItemContainer>
          {filteredProfessions.map(({ value, label }) => (
            <CardSelectItem key={value} value={value}>
              {label}
            </CardSelectItem>
          ))}
          {filteredProfessions.length === 0 ? (
            <p className="text-sm text-neutral-500 text-center py-4">
              Nenhuma profissão encontrada
            </p>
          ) : null}
        </CardSelectItemContainer>
      </CardSelectRoot>

      <div className="flex sticky bottom-0 self-end bg-white w-full">
        <Button loading={isLoading} fullWidth onClick={onContinue} disabled={!isValid}>
          <div className="flex flex-row gap-2 items-center">
            {buttonText}
            <ArrowRight size={24} />
          </div>
        </Button>
      </div>
    </div>
  );
};
